import { connect } from 'react-redux';

import { selectors as userSelectors } from 'dux/user';
import { actionCreators } from '../../dux/instances';
import AddDatabaseForm from './AddDatabaseForm';

const mapStateToProps = (state) => ({
  userRoles: userSelectors.getIdentityState(state).roles,
});

const mapDispatchToProps = {
  addInstanceDatabase: actionCreators.addInstanceDatabase,
  pullInstanceDatabases: actionCreators.pullInstanceDatabases,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddDatabaseForm);
